import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=1e040d76&scoped=true&"
import script from "./Parents.vue?vue&type=script&lang=js&"
export * from "./Parents.vue?vue&type=script&lang=js&"
import style0 from "./Parents.vue?vue&type=style&index=0&id=1e040d76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e040d76",
  null
  
)

export default component.exports